<template>
    <div class="modal fade" tabindex="-1" :id="id">
        <div class="modal-dialog modal-md">
          <form id="kt_modal_form_project" @submit.prevent="submitForm" class="form mt-5" >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ $t('tasks.addChecklist') }}</h5>
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor"/>
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor"/>
                    </svg>
                  </span>
                </div>
              </div>
              <div class="modal-body">
                <div class="row">
                  <Input
                      :name="'element'"
                      container-class="col-md-12 mb-5"
                      type="text"
                      :label="$t('label.title')"
                      :isRequired="true"
                      size="lg"
                      v-model="formData.title"
                  />
                  <Input
                      :name="`${id}-delay`"
                      container-class="col-md-12 mb-5"
                      type="number"
                      :label="$t('tasks.label.delay')"
                      :isRequired="false"
                      size="lg"
                      v-model="formData.delay_value"
                      :IsInputGroup="true"
                  >
                    <template #default>
                      <span class="input-group-text w-50 border-0 py-0">
                        <Select2
                            container-class="w-100 p-0"
                            select-class="form-select form-select-transparent w-100 fs-7 lh-1 fw-bold py-0 select2-hidden-accessible"
                            :multiple="false"
                            :show-search="false"
                            name="task-delay"
                            label-class="form-label"
                            v-model="formData.delay_unit"
                            :isRequired="false"
                        >
                              <option v-for="delay in delayFrequencyEnum" :value="delay.value"> {{ delay[locale] }} </option>
                          </Select2>
                      </span>
                    </template>
                  </Input>
                </div>
              </div>
              <div class="modal-footer">
                <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click.prevent="closeModal"></Button>
                <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="loading"></Button>
              </div>
            </div>
          </form>
        </div>
      </div>
</template>

<script setup>

import { defineProps, onMounted, ref, watch } from 'vue';
import { useStore } from "vuex";
import Button from "@/components/Button.vue"
import { computed } from 'vue';
import Input from "@/components/Input.vue";
import Select2 from "@/components/Select2.vue";
import {useLocales} from "@/composables/locales";

const emits = defineEmits(['callback'])

const props = defineProps({
  taskId: String,
  id:{type: String, default:"create_project_modal"} 
})

const store = useStore()
const { locale } = useLocales()

const formData = ref({
  title: "",
  task: props.taskId,
  delay_value: "",
  delay_unit: ""
})
const loading = ref(false)

const delayFrequencyEnum = computed(() => store.getters["configs/getFrequencyEnum"])

watch(() => props.taskId, (newVal) => {
  if (newVal) {
    formData.value = {
      title: "",
      task: newVal,
      delay_value: "",
      delay_unit: ""
    }
  }
}, { immediate: true })

function resetForm() {
  formData.value = {
    title: "",
    task: props.taskId,
    delay_value: "",
    delay_unit: ""
  }
}

function closeModal() {
  $('#'+props.id).modal('toggle')
}
function submitForm() {
  loading.value = true
  store.dispatch('checklists/createChecklist', formData.value)
      .then(() => {
        closeModal()
        resetForm()
        emits('callback')
      })
      .catch()
      .finally(() => loading.value = false)
}


onMounted(() => {
  store.dispatch('configs/loadFrequencyEnum')
})




</script>
